export class Constants {
    static KEY_DEFAULT_LANGUAGE: string = 'tu_dl';
}